import { useState } from "react";
import { Shield, Key } from "lucide-react";
import { BASE_URL } from "../../../../Api/Config";
export const SecuritySection = () => {
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [isChangingPassword, setIsChangingPassword] = useState(false);

  const handlePasswordChange = async () => {
    if (!passwordData.currentPassword || !passwordData.newPassword) {
      alert("Error: Please fill in all password fields.");
      return;
    }

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      alert("Error: New passwords don't match.");
      return;
    }

    if (passwordData.newPassword.length < 8) {
      alert("Error: Password must be at least 8 characters long.");
      return;
    }

    setIsChangingPassword(true);
    try {
      // API call to change password
      const token = localStorage.getItem('token');
      const response = await fetch(`${BASE_URL}/auth/change-password`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          currentPassword: passwordData.currentPassword,
          newPassword: passwordData.newPassword,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to change password');
      }

      setPasswordData({ 
        currentPassword: "", 
        newPassword: "", 
        confirmPassword: "" 
      });
      alert("Password updated! Your password has been changed successfully.");
    } catch (error) {
      console.error('Error changing password:', error);
      alert(`Error changing password: ${error.message}`);
    } finally {
      setIsChangingPassword(false);
    }
  };

  return (
    <div className="rounded-2xl shadow bg-white p-6 space-y-8">
      <h2 className="text-2xl font-semibold flex items-center gap-2">
        <Shield className="text-redtxt" /> Security Settings
      </h2>

      {/* Change Password */}
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <Key className="w-5 h-5 text-redtxt" />
          <h4 className="text-lg font-semibold">Change Password</h4>
        </div>

        <div className="grid gap-4 max-w-md">
          <div>
            <label className="block text-sm font-medium text-gray-700">Current Password</label>
            <input
              type="password"
              value={passwordData.currentPassword}
              onChange={(e) =>
                setPasswordData({ ...passwordData, currentPassword: e.target.value })
              }
              placeholder="Enter your current password"
              className="w-full border px-3 py-2 rounded"
              disabled={isChangingPassword}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">New Password</label>
            <input
              type="password"
              value={passwordData.newPassword}
              onChange={(e) =>
                setPasswordData({ ...passwordData, newPassword: e.target.value })
              }
              placeholder="Enter your new password"
              className="w-full border px-3 py-2 rounded"
              disabled={isChangingPassword}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Confirm New Password</label>
            <input
              type="password"
              value={passwordData.confirmPassword}
              onChange={(e) =>
                setPasswordData({ ...passwordData, confirmPassword: e.target.value })
              }
              placeholder="Confirm your new password"
              className="w-full border px-3 py-2 rounded"
              disabled={isChangingPassword}
            />
          </div>

          <button
            onClick={handlePasswordChange}
            disabled={isChangingPassword}
            className="bg-redbg text-white px-4 py-2 rounded w-full md:w-auto disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isChangingPassword ? "Updating..." : "Update Password"}
          </button>
        </div>
      </div>
    </div>
  );
};